import axios from "axios";
import Vue from "vue";
import store from "../store"


const gameApi = axios.create({
  baseURL: process.env.VUE_APP_GAME_API,
  withCredentials: true,
});

gameApi.interceptors.request.use(
  async function (config) {

    if (Vue.$cookies.isKey("_token")) {
      config.headers["Authorization"] = "Bearer " + Vue.$cookies.get("_token");
    }
    return config;
  },
  function (error) {
    return Promise.reject(error.response);
  }
);

gameApi.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    console.log("ERROR",error)
    if (error.response.status == 401) {
        const validate = await store.dispatch("user/userValidate");
        if (validate && validate.data && !validate.data.success) {
        Vue.$cookies.remove("_token");
        return Promise.reject(error);
      }else{
        return gameApi.request(error.config)
      }
    }
    return Promise.reject(error);
  }
);

export default gameApi;
